import React from "react";

const CardGrid = props => {
  const { className } = props;

  return (
    <div className={`grid-column-5 x-p-20 ${className}`.trim()}>
      {props.children}
    </div>
  );
}

export default CardGrid;